<template>
  <div class="score-container">
    <!-- <div class="image-area">
      <img src="../assets/fullscore.gif" alt="" v-show="fullFlag">
      <img src="../assets/fullscore.gif" alt="" v-show="halfFlag">
      <img src="../assets/fullscore.gif" alt="" v-show="cryFlag">
    </div> -->
    <p class="score-show">测评结果</p>
    <p class="score-show">类型1：<span class="color-square" ref="score1"></span></p>
    <p class="score-show">类型2：<span class="color-square" ref="score2"></span></p>
    <p class="score-show">类型3：<span class="color-square" ref="score3"></span></p>
    <p class="score-show">类型4：<span class="color-square" ref="score4"></span></p>
    <!-- <p class="score-show">真实性评分</p>
    <p class="score-show">题目1：9</p>
    <p class="score-show">题目2：6</p>
    <p class="score-show">题目3：8</p> -->
    <!-- <el-button type="primary" @click="backToHome">重新测评</el-button> -->
  </div>
</template>

<script>
export default {
  name: "Score",
  data() {
    return {
      score: this.$store.state.score,
      cat_score1: this.$store.state.cat_score1,
      cat_score2: this.$store.state.cat_score2,
      cat_score3: this.$store.state.cat_score3,
      fullFlag: false,
      halfFlag: false,
      cryFlag: false,
      sj_id: 0,
    }
  },
  created() {
    var that = this;
    var sj_id = that.$route.params.sj_id;
    that.sj_id = sj_id;
  },
  methods: {
    backToHome() {
      this.$store.commit('resetStore');
      this.$router.push('/')
    }
  },
  mounted() {
    var that = this;
    // if (this.score === 100) {
    //   this.fullFlag = true
    //   this.halfFlag = false
    //   this.cryFlag = false
    //   this.$refs.score.className = 'score-show green'
    // } else if (this.score < 100 && this.score >= 50) {
    //   this.fullFlag = false
    //   this.halfFlag = true
    //   this.cryFlag = false
    //   this.$refs.score.className = 'score-show yellow'
    // } else {
    //   this.fullFlag = false
    //   this.halfFlag = false
    //   this.cryFlag = true
    //   this.$refs.score.className = 'score-show red'
    // }
    that.$http({
      method: 'post',
      url: 'https://xl.880802.club/index/getRes',
      headers: {
        'Content-Type': 'multipart/form-data'
      },
      data: {
        sj_id: that.sj_id,
        uid: that.$store.state.uid
      }
    }).then((res) => {
      console.log(res.data);
      this.$refs.score1.className = `color-square ${res.data.leix1}`;
      this.$refs.score2.className = `color-square ${res.data.leix2}`;
      this.$refs.score3.className = `color-square ${res.data.leix3}`;
      this.$refs.score4.className = `color-square ${res.data.leix4}`;

    }).catch((error) => {
      console.log(error);
    });

  }
}
</script>

<style scoped>
.score-container {
  /* text-align: center; */
  display: flex;
  flex-direction: column;
  align-items: center;
}

.score-show {
  display: flex;
  align-items: center;
}

.image-area {
  height: 20rem;
}

.image-area img {
  height: 80%;
}

.score-show {
  font-size: 2rem;
  margin: 2rem 0;
  /* display: flex;
  align-items: center; */
}

.red {
  background-color: #ff4757;
}

.orange {
  background-color: #ff7f50;
}

.yellow {
  background-color: #eccc68;
}

.green {
  background-color: #2ed573;
}

.color-square {
  display: inline-block;
  width: 4rem;
  height: 2rem;
  /* background-color: #ff0000; */
  /* Replace with your desired color */
  margin-left: 5px;
  /* Adjust the spacing as needed */
}
</style>